// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const EllipseFilledGradient = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 36 36" fill="none" {...props}>
		<circle cx={18} cy={18} r={18} fill="url(#EllipseFilledGradient_tsx__a)" />
		<defs>
			<linearGradient
				id="EllipseFilledGradient_tsx__a"
				x1={0}
				y1={0}
				x2={0}
				y2={36}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#60B4E7" />
				<stop offset={1} stopColor="#6461E0" />
			</linearGradient>
		</defs>
	</svg>
);
export default EllipseFilledGradient;
